module.exports = __webpack_public_path__ + "media/images/icons/outlined/fast-backward-7092f809b10f1e00b74660d6768c6ba0.svg";